/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { createEntity, getEntity, reset, updateEntity } from './other-vitals.reducer';

export const OtherVitalsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const otherVitalsEntity = useAppSelector(state => state.otherVitals.entity);
  const loading = useAppSelector(state => state.otherVitals.loading);
  const updating = useAppSelector(state => state.otherVitals.updating);
  const updateSuccess = useAppSelector(state => state.otherVitals.updateSuccess);

  const handleClose = () => {
    navigate(`/other-vitals${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.respiratoryRate !== undefined && typeof values.respiratoryRate !== 'number') {
      values.respiratoryRate = Number(values.respiratoryRate);
    }
    if (values.bodyTemp !== undefined && typeof values.bodyTemp !== 'number') {
      values.bodyTemp = Number(values.bodyTemp);
    }
    if (values.bodySurfaceArea !== undefined && typeof values.bodySurfaceArea !== 'number') {
      values.bodySurfaceArea = Number(values.bodySurfaceArea);
    }
    if (values.painScore !== undefined && typeof values.painScore !== 'number') {
      values.painScore = Number(values.painScore);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...otherVitalsEntity,
      ...values,
      glucoUser: glucoUsers.find(it => it.id.toString() === values.glucoUser?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...otherVitalsEntity,
          glucoUser: otherVitalsEntity?.glucoUser?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.otherVitals.home.createOrEditLabel" data-cy="OtherVitalsCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.otherVitals.home.createOrEditLabel">Create or edit a OtherVitals</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="other-vitals-id"
                  label={translate('tinyMedicRestApp.otherVitals.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.otherVitals.respiratoryRate')}
                id="other-vitals-respiratoryRate"
                name="respiratoryRate"
                data-cy="respiratoryRate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.otherVitals.bodyTemp')}
                id="other-vitals-bodyTemp"
                name="bodyTemp"
                data-cy="bodyTemp"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.otherVitals.bodySurfaceArea')}
                id="other-vitals-bodySurfaceArea"
                name="bodySurfaceArea"
                data-cy="bodySurfaceArea"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.otherVitals.painScore')}
                id="other-vitals-painScore"
                name="painScore"
                data-cy="painScore"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.otherVitals.active')}
                id="other-vitals-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.otherVitals.timestampentry')}
                id="other-vitals-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.otherVitals.microSec')}
                id="other-vitals-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.otherVitals.lastupdated')}
                id="other-vitals-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.otherVitals.cursor')}
                id="other-vitals-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="other-vitals-glucoUser"
                name="glucoUser"
                data-cy="glucoUser"
                label={translate('tinyMedicRestApp.otherVitals.glucoUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/other-vitals" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default OtherVitalsUpdate;
